import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const MARKER_SIZE_PX = 44;
const MARKER_BORDER_PX = 2;
const CURRENT_RING_OFFSET_PX = 8;
const STEPPER_MAX_WIDTH_PX = 738;
const CONNECTOR_INSET_PX =
  MARKER_SIZE_PX / 2 + CURRENT_RING_OFFSET_PX + MARKER_BORDER_PX;

const useStyles = makeStyles({ name: 'CheckoutStepper' })(
  ({ palette, breakpoints, spacing }) => ({
    root: {
      display: 'none',
      [breakpoints.up('md')]: {
        display: 'flex',
      },
      width: '100%',
      maxWidth: pxToRem(STEPPER_MAX_WIDTH_PX),
      margin: '0 auto',
      padding: 0,
      listStyle: 'none',
    },
    step: {
      position: 'relative',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      gap: spacing(0),
      textAlign: 'center',
      color: palette.semantic.text.primary,
      '&:not(:last-of-type)::after': {
        content: '""',
        position: 'absolute',
        top: pxToRem(MARKER_SIZE_PX / 2),
        left: `calc(50% + ${pxToRem(CONNECTOR_INSET_PX)})`,
        right: `calc(-50% + ${pxToRem(CONNECTOR_INSET_PX)})`,
        borderTop: `${pxToRem(1)} solid ${palette.semantic.border.divider}`,
      },
    },
    stepComplete: {
      '&:not(:last-of-type)::after': {
        borderTopColor: palette.semantic.border.primary,
      },
    },
    marker: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      width: pxToRem(MARKER_SIZE_PX),
      height: pxToRem(MARKER_SIZE_PX),
      borderRadius: '50%',
      border: `${pxToRem(MARKER_BORDER_PX)} solid ${palette.semantic.border.divider}`,
    },
    markerFilled: {
      border: 'none',
      backgroundColor: palette.semantic.icon.primary,
      color: palette.semantic.text.buttonPrimary,
    },
    markerCurrent: {
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: pxToRem(-CURRENT_RING_OFFSET_PX),
        borderRadius: '50%',
        border: `${pxToRem(MARKER_BORDER_PX)} solid ${palette.semantic.border.primary}`,
      },
    },
    copy: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

export default useStyles;
